define('plugin/category/step/CategoryStep',['require','lib/controller/booking/BaseStep','plugin/category/collection/CategoryCollection','plugin/category/view/CategoryStepView'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
	var CategoryCollection = require('plugin/category/collection/CategoryCollection');
	var CategoryStepView = require('plugin/category/view/CategoryStepView');
	
	return BaseStep.extend({
		
		_step: 'category',
		_categoryCollection: null,
		_skipStep: false,
		
		/**
		 * Inits instance, collection, subscribe to events
		 */
		initialize: function() {
	        BaseStep.prototype.initialize.call(this);
	        
	        this._categoryCollection = this.getOption('collection');
	        this._categoryCollection.fetch();

	        this.listenTo(this._bookingModel, 'change:category_id', this.updateInfo);
	        this.listenTo(this._categoryCollection, 'sync', this.onDataFetch);

			// perform filter performers after all data fetched from server (like services, locations, etc.)
			this.listenTo(this._stepManager, 'step:fetch', this.performCollectionFilters);
	    },

        /**
         * Triggers init event
         */
        triggerInit: function () {
            this.triggerStepEvent('init', [this, this._categoryCollection]);
        },

		/**
		 * Calls before show view
		 */
		beforeViewShow: function () {
			this.performCollectionFilters();
		},

	    /**
	     * Returns step view
	     * 
	     * @return CategoryStepView
	     */
		getView: function () {
			return new CategoryStepView({
	    		collection: this._categoryCollection
	    	});
		},
		
		/**
		 * Calls when collection fetched from server
		 */
		onDataFetch: function () {
			this.triggerStepEvent('fetch');
			this.updateInfo();

			if (this._categoryCollection.getDataCollection().length < 1) {
                // do not skip empty category step
                this._stepManager.showStep('category');
			} else if (this._categoryCollection.getDataCollection().length == 1) {
				this._stepManager.hideStep('category');
			} else {
				this._stepManager.showStep('category');
			}

			this.done();
		},
		
		/**
		 * Updates booking info data
		 */
		updateInfo: function () {
			if(this._stepManager.isStepHidden('category') && this._categoryCollection.length > 1){
				this._stepManager.showStep('category');
			}

			this._bookingModel.set('category', this._categoryCollection.getModelObj(
	    		this._bookingModel.get('category_id')
	    	));
	    },

		/**
		 * Apply filters to collection before show step view
		 */
		performCollectionFilters: function () {
			this._categoryCollection.performFilters();
		},


		_autoSelectItem: function () {
			this.setIsSkipped(false);
			if (this._categoryCollection.length === 1) {
				this.setIsSkipped(true);
			}
            if (this._categoryCollection._once_synced && this._categoryCollection.isEmpty() && this._bookingModel.get('service_id')) {
                //skip empty category step only if service preselected
				this.setIsSkipped(true);
			}

			if (this._bookingModel.get('category_id')) {
				return;
			}

			if (this.isStepSkipped()) {
				var current = this._categoryCollection.first();
				if (current) {
					this._bookingModel.set('category_id', current.get('id'));
				} else {
                    this._stepManager.hideStep('category');
                }
			} else {
                this._stepManager.showStep('category');
            }
		},

	    /**
	     * Returns true if provider is selected
	     * 
	     * @return Boolean
	     */
	    isValid: function () {
			this.performCollectionFilters();
			this._autoSelectItem();
            
            var categoryId = this._bookingModel.get('category_id');
            var category = this._categoryCollection.getModelObj(categoryId);
            if (categoryId && this._categoryCollection.length && !category) {
                setTimeout(function () {
                    Backbone.history.navigate('error/e404', {
                        trigger: true,
                        replace: true
                    });
                });
            }

			if(this._stepManager.isStepHidden('category')) {
				return true;
			}
			if (this._bookingModel.get('category_id')) {
				return true;
			}
			return false;
	    }

	});
	
});
